module.exports = __webpack_public_path__ + "img/f1.bab0cdc4.png";